import React from "react";
import PropTypes from "prop-types";
import { Link, useLocation, useParams } from "react-router-dom";
import { Collapse, NavLink } from "reactstrap";
import {
  ACCOUNT_INFORMATION,
  ACCOUNT,
  ORDER_HISTORY
} from "../../../constants";

function AccountNavigation(props) {
  const location = useLocation();
  const params = useParams();

  const { user, isOpen, logout } = props;
  return (
    <Collapse className="navigation-links" isOpen={isOpen}>
      <div>
        <span className="hello-message d-flex justify-content-center align-items-center">
          Hi, {user.firstName}
        </span>
      </div>
      <div>
        <Link
          className="nav-link"
          to={`/${params.shortName}/${ACCOUNT}/${ORDER_HISTORY}${location.search}`}
        >
          Order History
        </Link>
      </div>
      <div>
        <Link
          className="nav-link"
          to={`/${params.shortName}/${ACCOUNT}/${ACCOUNT_INFORMATION}${location.search}`}
        >
          Account
        </Link>
      </div>
      <div>
        <NavLink className="nav-link nav-link-button" onClick={logout}>
          Sign Out
        </NavLink>
      </div>
    </Collapse>
  );
}

AccountNavigation.propTypes = {
  user: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
  logout: PropTypes.func.isRequired
};

export default AccountNavigation;
